<script>
import PagePushCard from '@maison/components/molecules/PagePushCard';

export default {
  components: {
    PagePushCard,
  },

  props: {
    cols: {
      type: Number,
      default: 1,
      validator: (value) => value > 0 && value < 5,
    },
    items: {
      type: Array,
      required: true,
    },
    dataTracking: {
      type: Object,
      default: null,
    },
  },

  emits: ['onItemClick'],

  computed: {
    classes() {
      const classes = ['cards-row'];

      if (this.cols > 1) {
        classes.push(`cards-row--${this.cols}-col`);
      }

      return classes;
    },
  },
};
</script>

<template>
  <div class="container">
    <div :class="classes">
      <page-push-card
        v-for="(item, index) in items"
        :key="item.id"
        v-bind="item"
        :data-tracking="dataTracking"
        @click="$emit('onItemClick', item, index)"
      />
    </div>
  </div>
</template>
